import { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import IPage from 'models/Page';
import { PageEditFormProps } from '../pageEditRegistry';
import QuestionForm from 'pages/OwnerPage/QuizFormPage/TabContentPages/Question/QuestionForm';

const QuestionPageForm: FC<PageEditFormProps> = ({ pageRef }) => {
  const { watch } = useFormContext();
  const pages: IPage[] = watch('pages') || [];
  const page = pages.find((p: IPage) => p.uuid === pageRef);
  const questionRef = page?.refs?.[0];

  if (!questionRef) return null;

  return <QuestionForm questionRef={questionRef} />;
};

export default QuestionPageForm;
